import { GeographyService } from '@/services/geography.service';
import { queryOptions } from '@tanstack/react-query';

const GEOGRAPHY_QUERY_STALE_TIME = 1000 * 60 * 2;
const GEOGRAPHY_QUERY_DEFAULTS = {
  retry: false,
  staleTime: GEOGRAPHY_QUERY_STALE_TIME,
  refetchOnWindowFocus: false,
} as const;

// `queryKey` only identifies the cache bucket.
const geographyQueryKeys = {
  all: ['geography'] as const,
  citiesWithCompanies: () => [...geographyQueryKeys.all, 'cities-with-companies'] as const,
};

// `queryOptions` connects a cache key with the fetcher and shared defaults.
export const geographyQueryOptions = {
  citiesWithCompanies: () =>
    queryOptions({
      queryKey: geographyQueryKeys.citiesWithCompanies(),
      queryFn: GeographyService.listCitiesWithCompanies,
      ...GEOGRAPHY_QUERY_DEFAULTS,
    }),
};
